<template>
  <div>
    <div class="listContent">
      <el-button class="goBack" @click="goBack">返回</el-button>
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-7293c593152247bdad5cfcc741b8b132')>-1"
          >添加设备</el-button
        >
        <!-- <el-button type="warning" plain>修改</el-button> -->
        <el-button type="info" @click="delConfirm(deleteStr)" plain v-if="userRoleList.indexOf('menu-7293c593152247bdad5cfcc741b8b132')>-1"
          >删除</el-button
        >
        <span class="searchInputText">设备名称</span>
        <el-input placeholder="请输入设备名称" v-model="search.name"></el-input>
        <span class="searchInputText">设备类型</span>
        <el-select v-model="search.type" placeholder="请选择设备类型">
          <el-option
            v-for="item in equipTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="searchInputText">所属组织</span>
        <el-input
          class="shotType"
          v-model="search.officeName"
          placeholder="请选择所属组织"
          @focus="openOffice(1)"
        ></el-input>
        <!-- <el-select v-model="search.roadType" placeholder="请选择所属组织">
            <el-option
            v-for="item in officeList"
            :key="item.officeCode"
            :label="item.officeName"
            :value="item.officeCode">
            </el-option>
        </el-select> -->
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>
      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            @selection-change="handleSelectionChangeL"
            :cell-class-name="cellcb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="order"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="code"
              label="设备编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="typeName"
              label="设备类型"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="officeName"
              label="所属组织"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="model"
              label="型号"
              width="150"
            ></el-table-column>
            <!-- <el-table-column prop="workStatus" label="状态" width="100">
              <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.workStatus == 0"
                  >离线</span
                >
                <span class="wordStatus_2" v-if="scope.row.workStatus == 1"
                  >空闲</span
                >
                <span class="wordStatus_3" v-if="scope.row.workStatus == 2"
                  >作业中</span
                >
                <span class="wordStatus_4" v-if="scope.row.workStatus == 3"
                  >紧停</span
                >
                <span class="wordStatus_4" v-if="scope.row.workStatus == 4"
                  >暂停</span
                >
              </template>
            </el-table-column> -->
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <span class="lookMore" @click="toInfo(scope.row)"
                  >查看更多</span
                >
                <span class="lookMore" @click="openConfirm(scope.row)" v-if="userRoleList.indexOf('menu-7293c593152247bdad5cfcc741b8b132')>-1&&scope.row.unmannedType == 0"
                  >修改</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="unmannedType"
              label="设备来源"
              width="100"
            >
              <template slot-scope="scope">
                <span class="" v-if="scope.row.unmannedType == 0"
                  >云平台</span
                >
                <span class="" v-if="scope.row.unmannedType == 1"
                  >本地平台</span
                >
              </template>
            </el-table-column>
            <el-table-column label="目标日均工作时长" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.targetDuration }}H</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand"
              label="品牌"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="leader"
              label="负责人"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              width="150"
            ></el-table-column>
            
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
      custom-class="addDevice"
      @close="closeDialog"
    >
      <div class="borderBlock borderPadding addAndEdit" v-if="formShow">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-row>
              <el-col :span="12">
                  <el-form-item label="设备名称" required prop="name">
                      <el-input class="shotType" v-model="modelObj.name" maxlength="20" placeholder="请输入设备名称" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="设备编号" required prop="code">
                      <el-input class="shotType" v-model="modelObj.code" maxlength="20" placeholder="请输入设备编号" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
                  <el-form-item label="设备类型" required prop="type">
                      <el-select v-model="modelObj.type" placeholder="请选择设备类型" class="shotType" @change="typeChange">
                          <el-option
                          v-for="item in equipTypeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            <el-col :span="12">
                <el-form-item label="所属组织" required prop="officeName">
                  <el-input
                    class="shotType"
                    v-model="modelObj.officeName"
                    :validate-event="false"
                    placeholder="请选择所属组织"
                    @focus="openOffice(2)"
                    @input="inputChange"
                    @blur="inputChange"
                    @change="inputChange"
                  ></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="12">
                  <el-form-item label="设备型号" required prop="model">
                      <el-select v-model="modelObj.model" placeholder="请先选择设备型号" class="shotType" @change="modelChange">
                          <el-option
                          v-for="item in ModelsList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="目标日均工作时长" required prop="targetDuration">
                      <el-input class="shotType" v-model="modelObj.targetDuration" maxlength="2" placeholder="请输入目标日均工作时长(H)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="12">
                  <el-form-item label="品牌">
                      <el-input class="shotType" v-model="modelObj.brand" maxlength="20" placeholder="请输入品牌" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="设备负责人">
                      <el-input class="shotType" v-model="modelObj.leader" maxlength="20" placeholder="请输入设备负责人" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="12">
                  <el-form-item label="联系电话">
                      <el-input class="shotType" v-model="modelObj.phone" maxlength="11" placeholder="请输入联系电话" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                  <el-form-item label="GPS编码" prop="symcIp">
                      <el-input class="shotType" v-model="modelObj.symcIp"  placeholder="请输入GPS编号" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col> -->
              <el-col :span="12">
                  <el-form-item label="吨位" required prop="tonnage" v-if="modelObj.type>28 && modelObj.type<35">
                      <el-input class="shotType" v-model="modelObj.tonnage"  placeholder="请输入吨位(t)" @input="inputChange"></el-input>
                  </el-form-item>
                  <el-form-item label="熨平板宽度" required prop="wheelBackWidth" v-if="modelObj.type==27||modelObj.type==28">
                      <el-input class="shotType" v-model="modelObj.wheelBackWidth"  placeholder="请输入熨平板宽度:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
                  <el-form-item label="铣刨宽度" required prop="millingWidth" v-if="modelObj.type==35">
                      <el-input class="shotType" v-model="modelObj.millingWidth"  placeholder="请输入铣刨宽度:单位(mm)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="modelObj.type!=35">    
              <el-col :span="12">
                  <el-form-item label="车身外壳长度" required prop="equipLength">
                      <el-input class="shotType" v-model="modelObj.equipLength"  placeholder="请输入车身外壳长度:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="车身外壳宽度" required prop="equipWidth">
                      <el-input class="shotType" v-model="modelObj.equipWidth"  placeholder="请输入车身外壳宽度:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="modelObj.type!=35">    
              <el-col :span="12">
                  <el-form-item label="GPS离车头距离" required prop="gpsHead">
                      <el-input class="shotType" v-model="modelObj.gpsHead"  placeholder="请输入GPS离车头距离:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="GPS离右侧距离" required prop="gpsRight">
                      <el-input class="shotType" v-model="modelObj.gpsRight"  placeholder="请输入GPS离右侧距离:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="modelObj.type!=35">
              <el-col :span="12">
                  <el-form-item label="前轮宽度" required prop="wheelHeadWidth" v-if="!(modelObj.type==27||modelObj.type==28)">
                      <el-input class="shotType" v-model="modelObj.wheelHeadWidth"  placeholder="请输入前轮宽度:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="后轮宽度" required prop="wheelBackWidth" v-if="!(modelObj.type==27||modelObj.type==28)">
                      <el-input class="shotType" v-model="modelObj.wheelBackWidth"  placeholder="请输入后轮宽度:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="modelObj.type!=35">
              <el-col :span="12">
                  <el-form-item label="前后轮的间隔" required prop="wheelGap" v-if="!(modelObj.type==27||modelObj.type==28)">
                      <el-input class="shotType" v-model="modelObj.wheelGap"  placeholder="请输入前后轮的间隔:单位(m)" @input="inputChange"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false;$refs.addModForm.resetFields()">取消</el-button>
        <el-button type="primary" @click="addModSubmit()">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="actionNameT"
      :visible.sync="officeShow"
      :close-on-click-modal="false"
      width="400px"
      @selection-change="handleSelectionChange"
      :row-key="fieldKey"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree
          :data="treeList"
          node-key="id"
          ref="maskTree"
          default-expand-all
          accordion
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"
        ></el-tree>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getEquipsList as fetchDtList,
  addEquip as addPost,
  editEquip as modPut,
  deleteEquip as delPut,
  // activeEngin
  getEquipTypeList,
  getOfficeList,
  getSysEquipModel,
  getSysEquipModels
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";

import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      input1: "",
      equipTypeList: [],
      officeList: [],
      ModelsList:[],//设备型号列表
      formShow:true,
      list: [{}],
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      search: {
        roadName: "",
        roadType: "",
        pageSize: 10,
        pageNo: 1,
        officeCode: '',
        officeName: "",
      },
      modelObj: {
        name:'',
        code: '',
        type: '',
        model:'',
        phone:'',
        leader:'',
        brand:'',
        officeCode: '',
        officeName:'',
        equipLength:'',
        targetDuration:'',
        tonnage:'',
        symcIp:'',
        equipWidth:'',
        millingWidth:'',
        gpsHead:'',
        gpsRight:'',
        wheelHeadWidth:'',
        wheelBackWidth:'',
        wheelGap:'',
      },
      activeObj: {
        active: "0",
      },
      pickerOptions: {},
      deleteStr: "",
      fieldKey: "ids",
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "基础管理",
          path: "/transfer/equipmentList",
        },
      ],
      officeShow: false,
      officeCode: "",
      officeName: "",
      treeList: [],
      checkedKeys: [],
      actionNameT: "",
      officeSetType: "",
      hasMannedType:false,
      userRoleList: localStorage.getItem("userRoleList"),
      listLoading:false,
      type:'',
    };
  },
  computed: {
    rules: function () {
      return {
        name:[{ required: true, message: "必填"  }],
        code: [{ required: true, message: "必填"  }],
        type: [{ required: true, message: "必填"  }],
        model:[{ required: true, message: "必填" ,trigger: "change" }],
        officeCode: [{ required: true, message: "必填"}],
        officeName:[{ required: true, message: "必填",trigger: "change"}],
        equipLength:[{ required: true, message: "必填"  }],
        targetDuration:[{ required: true, message: "必填"  }],
        tonnage:[{ required: true, message: "必填"  }],
        equipWidth:[{ required: true, message: "必填"  }],
        gpsHead:[{ required: true, message: "必填"  }],
        gpsRight:[{ required: true, message: "必填"  }],
        wheelHeadWidth:[{ required: true, message: "必填"  }],
        wheelBackWidth:[{ required: true, message: "必填"  }],
        wheelGap:[{ required: true, message: "必填"  }],
        millingWidth:[{ required: true, message: "必填"  }],
      };
    },
  },
  created() {},
  mounted() {
    //console.log(this.$store.state.arrowList)
    this.officeCode = this.$route.query.officeCode
    this.officeName = this.$route.query.officeName
    this.search.officeCode = this.$route.query.officeCode
    this.search.officeName = this.$route.query.officeName
    this.doSearch();
    this.$store.commit("setArrowList", this.arrowList);
    //获取设备类型
    getEquipTypeList({ pageSize: 100 }).then((res) => {
      //console.log(res)
      this.equipTypeList = res.data.content.list;
    });
    getOfficeList(this.search).then((res) => {
      //console.log(res)
      this.officeList = res.data.content;
    });
    getOfficeList(this.search).then((res) => {
      //console.log(res)
      let _arr = res.data.content.concat([]);

      let _getDepts = function (list, _depts) {
        for (let i = 0; i < list.length; i++) {
          let _m = list[i];
          _depts.push({
            id: _m.officeCode,
            label: _m.officeName,
            originalData: _m,
          });

          if (
            Object.prototype.hasOwnProperty.call(_m, "children") &&
            _m.children.length > 0
          ) {
            _depts[_depts.length - 1].children = [];
            _getDepts(_m.children, _depts[_depts.length - 1].children);
          }
        }
      };
      let _depts = [];
      _getDepts(_arr, _depts);
      this.treeList = _depts;
    });
  },
  watch:{
    type(newV){
      getSysEquipModels({type:newV,pageNo:1,pageSize:100}).then(res=>{
          this.ModelsList=[]
          res.data.content.list.map(item=>{
            this.ModelsList.push({
                label:item.model,
                value:item.model,
            })
            this.formShow=false;
            this.formShow=true;
          })
      })
    }
  },
  methods: {
    fetchDtList,
    addPost,
    modPut,
    delPut,
    closeDialog(){
      this.ModelsList = []
    },
    cellcb(row){
        if(row.row.unmannedType === 1){
            return "myCell"
        }
    },
    inputChange(){
      this.formShow=false;
      this.formShow=true;
    },
    modelChange:function(e){
        getSysEquipModel({model:e}).then(res=>{
            let item=res.data.content
            this.modelObj.tonnage = item.tonnage*1
            this.modelObj.equipLength  = item.equipLength*1
            this.modelObj.equipWidth  = item.equipWidth*1
            this.modelObj.gpsHead  = item.gpsHead*1
            this.modelObj.gpsRight  = item.gpsRight*1
            this.modelObj.wheelHeadWidth  = item.wheelHeadWidth*1
            this.modelObj.wheelBackWidth  = item.wheelBackWidth*1
            this.modelObj.wheelGap = item.wheelGap*1
            this.modelObj.targetDuration= item.targetDuration*1
            this.modelObj.brand = item.brand
            this.modelObj.millingWidth = item.millingWidth*1
            // this.modelObj.type = item.type*1
            console.log(this.modelObj,'this.modelObj')
            this.formShow=false;
            this.formShow=true;
        })
    },
    typeChange:function(e){
      getSysEquipModels({type:e,pageNo:1,pageSize:100}).then(res=>{
          this.ModelsList=[]
          res.data.content.list.map(item=>{
            this.ModelsList.push({
                label:item.model,
                value:item.model,
            })
            this.formShow=false;
            this.formShow=true;
          })
      })
      
    },
    openConfirm: function (obj) {
      if(obj.unmannedType==1){
        this.$message({
          message:"设备来源本地平台，云平台无法修改！",
          type:"warning"
        })
        return
      }
      this.openModbox(obj)
    },
    delConfirm: function (deleteStr) {
      if(this.hasMannedType){
        this.$message({
          message:"设备来源本地平台，云平台无法删除！",
          type:"warning"
        })
        return
      }
      this.deleteSignAll(deleteStr)
    },
    openOffice: function (val) {
      //console.log('111')
      this.actionNameT = "部门选择";
      this.officeShow = true;
      this.officeSetType = val;
      this.formShow=false;
      this.formShow=true;
    },
    handleNodeClickAdd(val) {
      //console.log(val)
      var that = this;
      if (this.officeSetType == 1) {
        that.search.officeCode = val.id;
        that.search.officeName = val.label;
      } else {
        // that.officeCode = val.id;
        // that.officeName = val.label;

        that.modelObj.officeName = val.label;
        that.modelObj.officeCode = val.id;
        that.mediaName=''
        setTimeout(function(){
          that.$set(that.modelObj,'officeName',val.label + ' ')
          that.$set(that.modelObj,'officeCode',val.id + ' ')
          // that.officeCode = val.id;
          // that.officeName = val.label;

          // that.modelObj.officeName = val.label;
          // that.modelObj.officeCode = val.id;
        },300)
      }
      this.officeShow = false;
      // this.formShow=false;
      // this.formShow=true;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // getDataList: function(){
    //     fetchDtList(this.search).then(res => {
    //         //console.log(res)
    //         this.list = addOrder(res.data.content.info.list)
    //         this.pageMsg = this.pageAssign(res.data.content.info);
    //     })
    // },
    doSearch: function () {
      this.getDataList(this.search, { listKey: "list" });
    },
    // toActive: function(setId){
    //     let params = {
    //         id: setId
    //     }
    //     activeEngin(params).then(res => {
    //         //console.log(res)
    //         this.getDataList(this.search, { listKey: "list" });
    //     })
    // },
    handleSelectionChange: function (val) {
      let deleteArr = [];
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].id);
      }
      this.deleteStr = deleteArr.join(",");
    },
    handleSelectionChangeL: function (val) {
      console.log(val)
      let deleteArr = [];
      this.hasMannedType=val.some(item=>{return item.unmannedType==1})
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].equipCode);
      }
      this.deleteStr = deleteArr.join(",");
    },
    toInfo: function (e) {
      //console.log(e)
      this.$router.push({
        name: "EquipmentInfo",
        params: { code: e.code, typeName: e.typeName,inArrow:'equipmentList' },
      });
    },
    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node">
          <span class="treeLable" title={node.label}>
            {node.label}
          </span>
          <span class="handleIcons">
            <i
              class="el-icon-circle-plus-outline"
              on-click={() => this.openSonDept(data.originalData)}
            ></i>
            <i
              class="el-icon-circle-close"
              on-click={() => this.deleteSign(data.originalData)}
            ></i>
            <i
              class="el-icon-edit-outline"
              on-click={() => this.openModBox(data.originalData)}
            ></i>
          </span>
        </span>
      );
    },
    goBack: function () {
      this.$router.push({ name: 'EquipmentCenter' });
    },
  },
  components: {
    ElPageCover,
  },
};
</script>
<style lang="scss">
.addDevice{
  width: 920px !important;
}
.equipmentList {
  .el-table__body-wrapper {
    tr {
      td {
        text-align: left;
      }
    }
  }
}
.myCell .el-checkbox__input {
  display: none
}
</style>
<style lang="scss" scoped="">
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
}
</style>